import src from "IMAGE";
export default { src, width: 1400, height: 769, blurWidth: 0, blurHeight: 0};
